<style scoped>
.cabinet-header {
  text-align: center;
  padding: 45px 0 10px 0;
}

.save-btn-block {
  text-align: center;
  padding: 35px 0 20px 0;
}

.user-cabinet-page .loader-block {
  margin-top: 150px;
}

.msg-cabinet-block {
  text-align: center;
}

.logout-all-modal-text {
    text-align: center;
    margin-bottom: 15px;
}

.logout-all-modal-btn-block {
    text-align: center;
    margin-bottom: 15px;
}

.logout-all-modal-btn-block a {
    margin: 10px;
}
</style>

<template>
<div class="container user-cabinet-page">
  <div class="loader loader-block" v-if="loader_block">
    <loader-component></loader-component>
  </div>
  <div v-if="!loader_block">
    <div class="col-12 cabinet-header">
      <h3>Настройки администратора</h3>
    </div>
    <div class="offset-md-3 col-md-6">
      <msg-component :type_msg="msg_general.type" :text="msg_general.text"></msg-component>
    </div>
      <div class="msg-cabinet-block offset-md-3 col-md-6">
        <msg-component :type_msg="msg_general.type" :text="msg_general.text"></msg-component>
      </div>
      <div class="col-12 row input-setting-block">
        <div class="offset-1 col-1 elips"></div>
        <div class="col-2 item-name">
          Старый пароль
        </div>
        <div class="col-7">
          <input v-bind:class="{fail: msg_password}" type="password" v-model="password">
    </div>
          <div v-if="msg_password" class="offset-4 col-7 after-input-msg">
            <p>{{msg_password}}</p>
          </div>
        </div>
        <div class="col-12 row input-setting-block">
          <div class="offset-1 col-1 elips"></div>
          <div class="col-2 item-name">
            Новый пароль
          </div>
          <div class="col-7">
            <input v-bind:class="{fail: msg_new_password, success: password_success}" type="password" v-model="new_password">
    </div>
            <div v-if="msg_new_password" class="offset-4 col-7 after-input-msg">
              <p>{{msg_new_password}}</p>
            </div>
          </div>
          <div class="col-12 row input-setting-block">
            <div class="offset-1 col-1 elips"></div>
            <div class="col-2 item-name">
              Повтор пароля
            </div>
            <div class="col-7">
              <input v-bind:class="{fail: msg_password_confirmation, success: password_success}" type="password" v-model="password_confirmation">
    </div>
              <div v-if="msg_password_confirmation" class="offset-4 col-7 after-input-msg">
                <p>{{msg_password_confirmation}}</p>
              </div>
            </div>
            <div class="col-md-12 save-btn-block">
              <a class="aquazor-btn" @click="savePassword">Сохранить новый пароль</a>
            </div>
          </div>
        </div>
</template>

<script>
import vSelect from 'vue-select'
import msg from './elements/msg.vue'
import axios from 'axios'
import config from '@/config.js'
import loader from './elements/loader.vue'

export default {
  created() {
  },
  components: {
    'v-select': vSelect,
    'loader-component': loader,
    'msg-component': msg,
  },
  data() {
    return {
      msg_general: {
        type: 'hidden',
        text: ''
      },
      user_name: null,
      msg_user_name: '',
      name_success: false,
      loader_block: false,
      password: '',
      new_password: '',
      password_confirmation: '',
      msg_password: '',
      msg_new_password: '',
      msg_password_confirmation: '',
      password_success: false
    }
  },
  methods: {
    saveName: function () {
      saveName(this)
    },
    savePassword: function () {
      savePassword(this)
    },
    logoutAll: function () {
        logoutAll(this)
    },
    hideLogoutallModal () {
      this.$refs.logoutallModal.hide()
    }
  },
}

function savePassword(vue_obj) {
  vue_obj.msg_general = {
    type: 'hidden',
    text: ''
  }
  vue_obj.msg_password = ''
  vue_obj.msg_new_password = ''
  vue_obj.msg_password_confirmation = ''
  vue_obj.password_success = false
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('old_password', vue_obj.password)
  post_data.set('password', vue_obj.new_password)
  post_data.set('password_confirmation', vue_obj.password_confirmation)

  axios({
      method: 'POST',
      url: config.API_HOST + '/admin-user/change_password',
      data: post_data
    })
    .then(function (request) {
      console.log(request)
      vue_obj.password_success = true
    })
    .catch(function (error) {
      if (!!error.response.data.exception) {
        vue_obj.msg_general = {
          type: 'alert',
          text: error.response.data.exception
        }
      }
      if (!!error.response.data.fields_exceptions['old_password']) {
        vue_obj.msg_password = error.response.data.fields_exceptions['old_password']
      }
      if (!!error.response.data.fields_exceptions['password']) {
        vue_obj.msg_new_password = error.response.data.fields_exceptions['password']
      }
      if (!!error.response.data.fields_exceptions['password_confirmation']) {
        vue_obj.msg_password_confirmation = error.response.data.fields_exceptions['password_confirmation']
      }
    })
}
</script>



// WEBPACK FOOTER //
// src/components/user-cabinet.vue